import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormControlsUtilsModule } from '../form-controls-utils/form-controls-utils.module';
import { TextAreaControlComponent } from './text-area-control/text-area-control.component';
import { TextAreaFormControlComponent } from './text-area-form-control.component';



@NgModule({
  declarations: [
    TextAreaFormControlComponent,
    TextAreaControlComponent
  ],
  exports: [TextAreaFormControlComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormControlsUtilsModule,
    MatProgressSpinnerModule,
    TextFieldModule
  ]
})
export class TextAreaFormControlModule { }
